import { connect } from "react-redux";

import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withControlDebugInfo } from "../../withControlDebugInfo";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";
import { AbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { FormActionHandlerExecutionInjectableProps } from "../../Internals/FormActionHandlers/WithFormActionHandlerExecution";
import { withFocusManagement } from "../../Services/FocusManagement/withFocusManagement";
import { printExcelAction } from "../../../Engine/ActionCreators/FufUploadActionCreator";

import { DownloadExcelButton } from "./DownloadExcelButton";

export interface DownloadExcelButtonContainerProps extends FormActionHandlerExecutionInjectableProps {
    bindingPath?: AbsoluteModelPath;
    pathToTable: string;
    viewModelSelect: ViewModelSelect;
}

const mapDispatchToProps = (dispatch: CandyDispatch, ownProps: DownloadExcelButtonContainerProps) => ({
    onClick: async () => await dispatch(printExcelAction(ownProps.pathToTable)),
});

export const DownloadExcelButtonContainer = withResolvePaths(
    withFocusManagement(
        withControlDebugInfo(withViewModelSelect(connect(undefined, mapDispatchToProps)(DownloadExcelButton)))
    )
);
